import React, { useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Grid, Accordion, AccordionDetails, AccordionSummary, Box } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ApiService from "../../functions/apiService";

const OrderList = () => {
  const [rows, setRows] = useState([])

  const loadData = () => {
    ApiService.get(`/getLists?filter=`)
      .then(({ data }) => {
        const formattedRows = data.data.map((row, index) => ({
          ...row,
          id: row.Emp_Code || index,
          ordered: parseInt(row?.overtime_lists?.find(item => item.Overtime_List == 'ORDERED')?.Hours.split('.')[0]) || 0
        }));

        const sortedRows = formattedRows.sort((a, b) => {
          if (a.ordered < b.ordered) return 1;
          if (a.ordered > b.ordered) return -1;
          return 0;
        });

        setRows(sortedRows);
      })
      .catch((e) => {
        console.log('Error in lists api');
      });
  };

  useEffect(() => {
    loadData()
  }, [])

  return (
    <>
      <Accordion
        sx={{
          '&.MuiAccordion-root': {
            margin: '0px !important',
            boxShadow: 'none !important'
          },
          '& .MuiButtonBase-root': {
            backgroundColor: '#BF1D2D',
            minHeight: '42px !important',
            color: '#fff',
            boxShadow: 'none !important'
          },
          '& .MuiAccordionSummary-content': {
            margin: '0px !important',
          },
          '& .MuiAccordionSummary-expandIconWrapper': {
            color: '#fff'
          },
          '& .MuiAccordionDetails-root': {
            padding: '0px !important'
          },
        }}>
        <AccordionSummary
          expandIcon={<ArrowDropDownIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography component="span">Order List</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box sx={{
            boxShadow: '1px 1px 5px rgba(0, 0, 0, 0.5)', overflow: 'auto', msOverflowStyle: 'none',
            scrollbarWidth: 'none',
            maxHeight:'60vh'
          }}>
            <TableContainer>
              <Table sx={{ maxWidth: "100%" }} aria-label="transposed table">
                <TableHead sx={{ backgroundColor: "#F4F4F4" }}>
                  <TableRow>
                    <TableCell>Field</TableCell>
                    <TableCell>Order</TableCell>
                  </TableRow>
                </TableHead>
                {rows.map((value, idx) => (
                  <TableRow key={idx}>
                    <TableCell>{value?.fullName}</TableCell>
                    <TableCell>{value?.ordered}</TableCell>
                  </TableRow>
                ))}
                <TableBody>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </AccordionDetails>
      </Accordion>
    </>
  )
}

export default OrderList;